import React from 'react'
import EditEventFormTypeWrapper from './EditEventFormTypeWrapper';
import { Field } from 'formik';
import TextValueField from '../general/TextValueField';
import formatPrice from '../func/formatPrice';


const EditEventFormExtras = ({ values, rows = 10, activeField, setActiveField }) => {
    return (
        <EditEventFormTypeWrapper headline={'Extras'}>
            <div className='extras-container'>
                <div className='extras-textarea'>
                    <Field
                        id={'extra'}
                        name={'extra'}
                        as="textarea"
                        rows={rows}
                    />
                </div>
                <div className='price-item-row extras-price'>
                    <TextValueField
                        name={'extra_price'}
                        label="Preis"
                        type="number"
                        formValue={0}
                        currValue={values.extra_price}
                        isPrice={true}
                        activeField={activeField}
                        setActiveField={setActiveField}
                    />
                    <p className='item-total'>
                        <span className='text-small-regular'>{'= ' + formatPrice(values.extra_price) + ' €'}</span>
                    </p>
                </div>
            </div>
        </EditEventFormTypeWrapper>
    );
}

export default EditEventFormExtras;